var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useDropdownMenuContext } from '../dropdown-menu-context';
import { SearchIcon } from '../../icon';
import { Input, InputAdornment } from '../../input';
import { styled } from '../../styled';
import clsx from '../../utils/clsx';
import { dropdownMenuSearchClasses, dropdownMenuSearchComponentName, getDropdownMenuSearchUtilityClass, } from './dropdown-menu-search-classes';
import { useMergedClasses } from '../../styles/classes';
var Root = styled('div', { name: dropdownMenuSearchComponentName, slot: 'Root' })(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing(0, 0, 1),
    });
});
export var DropdownMenuSearch = React.forwardRef(function (props, ref) {
    var _a = props["aria-label"], ariaLabel = _a === void 0 ? 'Search' : _a, defaultValue = props.defaultValue, inputRef = props.inputRef, onBlur = props.onBlur, onChange = props.onChange, placeholder = props.placeholder, value = props.value, className = props.className, _b = props.InputProps, InputProps = _b === void 0 ? {} : _b, propClasses = props.classes, 
    // MenuList adds this. We need to remove to avoid focus
    rootProps = __rest(props, ['aria-label', "defaultValue", "inputRef", "onBlur", "onChange", "placeholder", "value", "className", "InputProps", "classes"]);
    var classes = useMergedClasses(dropdownMenuSearchClasses, getDropdownMenuSearchUtilityClass, propClasses);
    var size = useDropdownMenuContext().size;
    return (React.createElement(Root, __assign({ ref: ref, className: clsx(classes.root, className), ownerState: { size: size } }, rootProps),
        React.createElement(Input, __assign({ autoFocus: true, fullWidth: true, size: "small", "aria-label": ariaLabel, className: classes.input, defaultValue: defaultValue, inputRef: inputRef, onBlur: onBlur, onChange: onChange, placeholder: placeholder, value: value, inputProps: {
                tabIndex: 1,
            }, startAdornment: React.createElement(InputAdornment, { position: "start" },
                React.createElement(SearchIcon, { size: "1em" })) }, InputProps))));
});
